// extracted by mini-css-extract-plugin
export default {"NewBox":"box_NewBox__cTZlj","row":"box_row__FhlpS","description":"box_description__x6s1W","title":"box_title__FfenT","icon":"box_icon__CkPEn"};